import React from 'react';

import { Box, Tab, Tabs as MuiTabs } from '@mui/material';

export type Tab = {
  id: number;
  name: string;
  className?: string;
};

type Props = {
  tabs: Tab[];
  activeTab: Tab;
  onTabChange: (tab: Tab) => void;
};

export const Tabs: React.FC<Props> = ({ tabs, activeTab, onTabChange }) => {
  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    const tab = tabs.find((t) => t.id === newValue);
    if (tab) {
      onTabChange(tab);
    }
  };

  return (
    <Box sx={{ mb: 2 }}>
      <MuiTabs
        value={activeTab.id}
        onChange={handleChange}
        aria-label="signal tabs"
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          '& .MuiTabs-indicator': {
            backgroundColor: '#5ecba1',
          },
        }}
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.id}
            label={tab.name}
            value={tab.id}
            className={tab.className}
            sx={{
              textTransform: 'none',
              minWidth: 120,
              color: 'text.secondary',
              '&.Mui-selected': {
                color: 'text.secondary',
              },
            }}
          />
        ))}
      </MuiTabs>
    </Box>
  );
};
